module.exports = __webpack_public_path__ + "media/country_flags/mm-5e60b730.png";